import { LocalizedLink } from "@/i18n/language";

export default function BookingCompanyNotice({ isDe }: { isDe: boolean }) {
  return (
    <p className="mt-3 flex items-start gap-2 text-xs text-foreground-500 leading-relaxed">
      <i className="ri-shield-check-line mt-0.5 text-accent-600 flex-shrink-0"></i>
      <span>
        {isDe ? (
          <>
            Alle Buchungen für Villen, Tagestouren, Rundreisen, Erlebnistouren und Hochzeiten laufen über unser eigenes registriertes Reiseunternehmen{" "}
            <LocalizedLink
              to="/impressum"
              className="text-accent-700 hover:text-accent-800 underline underline-offset-2 font-medium cursor-pointer whitespace-nowrap"
            >
              Bali Chakra Tour
            </LocalizedLink>
            .
          </>
        ) : (
          <>
            All bookings for villas, day trips, round trips, adventure tours and weddings are handled by our own registered travel company{" "}
            <LocalizedLink
              to="/impressum"
              className="text-accent-700 hover:text-accent-800 underline underline-offset-2 font-medium cursor-pointer whitespace-nowrap"
            >
              Bali Chakra Tour
            </LocalizedLink>
            .
          </>
        )}
      </span>
    </p>
  );
}